import React, { useEffect, useState } from "react";
import { Save, Lock, Unlock, ExternalLink } from "lucide-react";
import api from "../../lib/api";

const EMPTY = {
    stats_public: true,
    registrations_open: true,
    gallery_drive_url: "",
};

export default function AdminSettings() {
    const [s, setS] = useState(EMPTY);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        api.get("/settings").then(r => setS({
            stats_public: !!r.data.stats_public,
            registrations_open: r.data.registrations_open !== false,
            gallery_drive_url: r.data.gallery_drive_url || "",
        }));
    }, []);

    const save = async () => {
        await api.put("/settings", {
            stats_public: s.stats_public,
            registrations_open: s.registrations_open,
            gallery_drive_url: (s.gallery_drive_url || "").trim(),
        });
        setSaved(true);
        setTimeout(() => setSaved(false), 2000);
    };

    return (
        <div data-testid="admin-settings">
            <h1 className="font-display text-4xl uppercase tracking-widest mb-6">Paramètres</h1>
            <div className="glass-card p-6 max-w-xl">
                <label className="flex items-center justify-between gap-4 py-3 border-b border-white/10">
                    <div>
                        <div className="font-display text-xl uppercase tracking-wide">Stats joueurs publiques</div>
                        <div className="text-xs text-white/60">Activer le toggle public sur la page Pointeurs et la fiche match.</div>
                    </div>
                    <input type="checkbox" checked={s.stats_public} onChange={e => setS({ ...s, stats_public: e.target.checked })} className="w-6 h-6 cursor-pointer accent-[#7FD93C]" data-testid="toggle-stats-public" />
                </label>
                <label className="flex items-center justify-between gap-4 py-3 border-b border-white/10">
                    <div className="flex-1 min-w-0">
                        <div className="font-display text-xl uppercase tracking-wide flex items-center gap-2">
                            {s.registrations_open ? <Unlock size={18} className="text-[#7FD93C]" /> : <Lock size={18} className="text-rose-400" />}
                            Inscriptions ouvertes
                        </div>
                        <div className="text-xs text-white/60">Quand désactivé, le formulaire d&apos;inscription public est verrouillé et affiche un message « inscriptions fermées ».</div>
                    </div>
                    <input type="checkbox" checked={s.registrations_open} onChange={e => setS({ ...s, registrations_open: e.target.checked })} className="w-6 h-6 cursor-pointer accent-[#7FD93C]" data-testid="toggle-registrations-open" />
                </label>

                <div className="py-3 border-b border-white/10">
                    <div className="font-display text-xl uppercase tracking-wide flex items-center gap-2">
                        <ExternalLink size={18} className="text-[#4FE0D5]" />
                        Lien galerie complète
                    </div>
                    <div className="text-xs text-white/60 mb-2">
                        URL externe (Google Drive, Google Photos, iCloud…) affichée en gros bouton sur la page Galerie publique. Laissez vide pour cacher le bouton.
                    </div>
                    <input
                        type="url"
                        placeholder="https://drive.google.com/…"
                        value={s.gallery_drive_url}
                        onChange={e => setS({ ...s, gallery_drive_url: e.target.value })}
                        className="input-field w-full font-mono text-sm"
                        data-testid="input-gallery-drive-url"
                    />
                </div>

                <button onClick={save} className="btn-primary mt-5" data-testid="btn-save-settings"><Save size={14} /> Enregistrer</button>
                {saved && <span className="ml-3 text-[#7FD93C]">✓ Enregistré</span>}
            </div>
        </div>
    );
}
